const sitenav = [
	{
		icon: 'assignment',
		label: 'Job Center',
		routeName: null,
		children: [
			{
				icon: null,
				label: 'Manage Jobs',
				routeName: 'jobs-manage',
                permission: ''
			},
			{
				icon: null,
				label: 'Requests',
				routeName: 'jobs-requests',
                permission: ''
			},
			{
				icon: null,
				label: 'Premedia Search',
				routeName: 'premedia-search',
                permission: ''
			},
		]
	},
	{
		icon: 'grid_on',
		label: 'Project Tools',
		routeName: null,
		permission: 'SILA_PERMISSION_ORGANIZATION_DEPT_RESOURCE_ACCESS',
		children: [
			{
				icon: null,
				label: 'Routing Board',
				routeName: 'tools-routing',
                permission: ''
			},
			{
				icon: null,
				label: 'Resource Allocation',
				routeName: 'tools-allocation',
                permission: ''
			},
		]
	},
	{
		icon: 'calendar_today',
		label: 'Department Resources',
		routeName: null,
		permission: 'SILA_PERMISSION_ORGANIZATION_DEPT_RESOURCE_ACCESS',
		roles: ['SILA_ROLE_ORGANIZATION_ADMIN','SILA_ROLE_ORGANIZATION_MANAGER'],
		children: [
			{
				icon: null,
				label: 'Time Off & Absences',
				routeName: 'department-absences',
                permission: ''
			},
			{
				icon: null,
				label: 'Department Events',
				routeName: 'department-events',
                permission: 'SILA_PERMISSION_ORGANIZATION_ORGANIZATION_EVENT_CREATE',
			},
			{
				icon: null,
				label: 'Calendar',
				routeName: 'department-calendar',
                permission: ''
			},
			{
				icon: null,
				label: 'Dept Directory',
				routeName: 'department-directory',
                permission: ''
			},
			{
				icon: null,
				label: 'Memos',
				routeName: 'department-memos',
                permission: ''
			},
			{
				icon: null,
				label: 'Documents',
				routeName: 'department-documents',
                permission: ''
			},
		]
	},
	{
		icon: 'settings',
		label: 'Manage Users',
		routeName: 'admin-users',
		permission: 'SILA_PERMISSION_ORGANIZATION_USER_MANAGE_USERS',
		children: null
	}
]

export default sitenav
